module.exports = __webpack_public_path__ + "static/media/25.7481fdc6.png";